import { app } from '../../../../app';
import { Controller } from './supported-application-types.controller';

app.component('companySupportedApplicationTypes', {
    bindings: {
        appCategories: '<',
        companyId: '<',
        appTypes: '<',
        appPermissions: '<',
        protocolstr: '<',
    },
    controller: Controller,
    templateUrl: require('./supported-application-types.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-applications/supported-application-types/supported-application-types.component.js